/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { trackModelSchema } from "./trackModelSchema.ts";
import { z } from "zod";

export const trackModelPagedResultSchema = z.object({
    "totalItems": z.number().int(),
"itemsQuantity": z.number().int(),
"itemsOffset": z.number().int(),
"items": z.array(z.lazy(() => trackModelSchema))
    })